import { FetchState } from '@/types/fetchState';
import { defineStore } from 'pinia';
import { CustomCalcResultResponse } from '@/generated/src';
import { generateAPI } from '@/shared/lib';

export const useCustomCalcResultStore = defineStore('customCalcResult', {
  state: (): FetchState<CustomCalcResultResponse> => ({
    data: null,
    loading: false,
    error: null,
  }),

  getters: {
    /**
     * 全結果データ
     */
    customCalcResult: (state): CustomCalcResultResponse | null => state.data ?? null,
  },

  actions: {
    /**
     * 全結果データを取得
     */
    async fetch(basinId: string, stationId: string, filename: string) {
      this.loading = true;
      this.error = null;

      try {
        this.data = await generateAPI().customCalcApi.customCalcResultApiApiCustomCalcResultBasinIdStationIdGet({
          basinId,
          stationId,
          filename,
        });
      } catch (error) {
        this.error = error as Error;
        throw error;
      } finally {
        this.loading = false;
      }
    },

    /**
     * データをクリア
     */
    clear() {
      this.data = null;
      this.error = null;
    },
  },
});
